var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add export",on:{"click":_vm.exportExcel}},[_c('img',{staticClass:"logo",attrs:{"src":require("../../public/image/export.png")}}),_c('span',{staticClass:"addText"},[_vm._v("导出")])])}
var staticRenderFns = []

export { render, staticRenderFns }